import React, { useEffect, useState } from "react";
import AuthUser from "../../services/AuthUser";
import WhatsAppScrollButton from "../floatingwhatsApp";
import Footer from "../footer";
import CircularScrollProgress from "../Circularprogress";
import ProfileSection from "./ProfileSection";
import CitySelector from "../User/CitySelectore";
import RightSidebarAds from "./TopRightAd";









const AgentProfile = () => {
   const [agenttt, setUser] = useState({});


       const { http, token } = AuthUser();


  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("agentData"));
    if (storedUser) {
      setUser(storedUser);
    }
  }, []);


  
  const agentData = JSON.parse(localStorage.getItem("agentData"));
  const agent = JSON.parse(localStorage.getItem("agent"));
  

  // ✅ Modal open handler
  const openEditModal = (selectedUser) => {
    setUser({
      name: selectedUser.name,
      mobile1: selectedUser.mobile1 || "",
      address: selectedUser.address,
      user_id: selectedUser.user_id,
    });
    setShowModal(true);
  };
  
  const closeModal = () => {
    setShowModal(false);
  };
  
  // ✅ Update user handler
  const handleUpdateUser = async (e) => {
    e.preventDefault();
    try {
      const storedUser = JSON.parse(localStorage.getItem("agent"));
      const response = await http.put(`/update-agent/${storedUser.id}`, {
        name: agenttt.name,
        mobile1: agenttt.mobile1,
        address: agenttt.address,
     
       
      });
  
      if (response.data && response.data.status) {
        console.log("Agent updated:", response.data);
  
        // ✅ Update localStorage and state
        localStorage.setItem("agentData", JSON.stringify(response.data.agent));
        setUser(response.data.agent);
  
        // ✅ Show success alert
        alert("✅ Agent updated successfully.");
  
        // ✅ Close modal
        setShowModal(false);
      } else {
        alert("⚠️ Unexpected response format.");
      }
    } catch (error) {
      console.error("Error updating user:", error);
  
      // ✅ Show error from Laravel validation if exists
      if (error.response && error.response.data && error.response.data.errors) {
        const errorMessages = Object.values(error.response.data.errors)
          .flat()
          .join("\n");
        alert(`❌ Update failed:\n${errorMessages}`);
      } else {
        alert("❌ Something went wrong while updating.");
      }
    }
  };
  

  // ✅ Utility




  return (
    <div>
     <div className="row">
      <div className="col-8">
      <div className="container mt-5 ">
        <div className="row justify-content-center">
          <div className="col-md-11">
            <div className="card shadow-lg">
              <div className="card-body bg-light">
                {/* Profile Top Section */}
                <div className="pro-top d-flex">
                 <ProfileSection/>

                  <div className="pro d-flex flex-column justify-content-center mx-4">
                    <h4 className="mb-2 font-weight-bold">{agentData?.name}</h4>
                    <p className="text-muted">
                      Joined on {new Date(agentData?.created_at).toLocaleDateString()}
                    </p>
                  </div>
                </div>

                <hr />

                {/* Profile Details */}
                <div className="row">
                  <div className="col-md-12">
                    <h5 className="font-weight-bold">Profile Details</h5>
                    <hr />
                    <div className="row mx-auto">
                      <div className="col-md-6 mb-4">
                        <strong>Name</strong>
                      </div>
                      <div className="col-md-6 mb-4 text-capitalize">{agentData?.name}</div>
                      <div className="col-md-6 mb-4">
                        <strong>User ID</strong>
                      </div>
                      <div className="col-md-6 mb-4">{agent?.user_id}</div>

                      <div className="col-md-6 mb-4">
                        <strong>Mobile</strong>
                      </div>
                      <div className="col-md-6 mb-4">{agentData?.mobile1}</div>

                      <div className="col-md-6 mb-4">
                        <strong>Email ID</strong>
                      </div>
                      <div className="col-md-6 mb-4 ">{agentData?.email}</div>
                      <div className="col-md-6 mb-4">
                        <strong>Address</strong>
                      </div>
                      <div className="col-md-6 mb-4 text-capitalize">{agentData?.address}</div>
                    


                    </div>

                    <div className="text-center mt-4">
                      {/* Edit button onClick={() => openEditModal(user)} */}
                      <button className="btn btn-danger px-4" onClick={() => openEditModal(agenttt)}  >
                        EDIT
                      </button>


                    </div>
                    {showModal && (
                      <div className="modal d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
                        <div className="modal-dialog" role="document">
                          <form onSubmit={handleUpdateUser}>
                            <div className="modal-content">
                              <div className="modal-header">
                                <h5 className="modal-title">Edit Profile</h5>
                                <button type="button" className="btn-close" onClick={closeModal}>
                          
                                </button>
      
                              </div>

                              <div className="modal-body">
                                <div className="form-group">
                                  <label>Name</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={agenttt.name}
                                    onChange={(e) => setUser({ ...agenttt, name: e.target.value })}
                                    required
                                  />
                                </div>

                                <div className="form-group">
                                  <label>Mobile</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={agenttt.mobile1}
                                    onChange={(e) => setUser({ ...agenttt, mobile1: e.target.value })}
                                  />
                                </div>

                           
                                <CitySelector
                                          newData={agenttt}
                                          setNewData={setUser}
                                          fieldKey="address"
                                          errors={''}
                                       />

                              </div>

                              <div className="modal-footer">
                                <button className="btn btn-primary" type="submit">Save changes</button>
                                <button type="button" className="btn btn-secondary" onClick={closeModal}>Close</button>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    )}


                  </div>
                </div>
              </div>
            </div>

            {/* Documents Section (Grid View) */}
         



          </div>
        </div>
      </div>
      </div>
      <div className="col-4">
  <div className="mt-5 p-3 rounded adds shadow" style={{ backgroundColor: '#f1f9ff', border: '2px solid #a0d4ff' }}>
    <h4 className="text-primary mb-3 text-center">🔥 Trending Ads</h4>
    <RightSidebarAds />
  </div>
</div>



      </div>
      <div className="space40 bg-white"></div>
      <WhatsAppScrollButton />
      <Footer />
      <CircularScrollProgress />
    </div>
  );
};

export default AgentProfile;
